var _circle, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#FBCB4E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_745_10763)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.99883,
    cy: 6.00078,
    r: 5.2,
    fill: "#FFCF52"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_745_10763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.40781 4.42258C7.37338 4.11703 7.23136 3.88033 6.98175 3.71249C6.73214 3.5425 6.41798 3.4575 6.03926 3.4575C5.76813 3.4575 5.53359 3.50054 5.33562 3.58661C5.13765 3.67053 4.9838 3.78673 4.87406 3.9352C4.76647 4.08152 4.71267 4.24829 4.71267 4.4355C4.71267 4.59258 4.74925 4.72814 4.82241 4.84219C4.89773 4.95623 4.99563 5.05199 5.11614 5.12945C5.23879 5.20476 5.37005 5.26824 5.50992 5.31989C5.64978 5.36938 5.78427 5.41026 5.91338 5.44254L6.55892 5.61038C6.7698 5.66202 6.98605 5.73196 7.20769 5.82018C7.42932 5.9084 7.63482 6.0246 7.82418 6.16877C8.01354 6.31294 8.16632 6.49154 8.28251 6.70457C8.40086 6.9176 8.46004 7.17259 8.46004 7.46954C8.46004 7.84395 8.36321 8.1764 8.16954 8.4669C7.97803 8.75739 7.69938 8.98656 7.33357 9.1544C6.96991 9.32224 6.52987 9.40616 6.01344 9.40616C5.51852 9.40616 5.09031 9.32762 4.72881 9.17054C4.36731 9.01346 4.08435 8.79074 3.87992 8.5024C3.6755 8.21191 3.56253 7.86762 3.54102 7.46954H4.5416C4.56097 7.70839 4.63844 7.90743 4.774 8.06666C4.91171 8.22374 5.08709 8.34102 5.30011 8.41848C5.5153 8.4938 5.75092 8.53145 6.00698 8.53145C6.28887 8.53145 6.53955 8.48734 6.75904 8.39912C6.98067 8.30874 7.15497 8.18394 7.28193 8.0247C7.40888 7.86332 7.47236 7.67503 7.47236 7.45985C7.47236 7.26404 7.41641 7.10373 7.30452 6.97893C7.19478 6.85412 7.04523 6.75083 6.85587 6.66907C6.66866 6.5873 6.45671 6.51521 6.22001 6.45281L5.43891 6.23978C4.90956 6.09561 4.48996 5.88366 4.1801 5.60392C3.87239 5.32419 3.71854 4.95408 3.71854 4.49359C3.71854 4.11272 3.82183 3.78027 4.0284 3.49623C4.23497 3.21219 4.51471 2.99163 4.8676 2.83455C5.2205 2.67532 5.61858 2.5957 6.06185 2.5957C6.50943 2.5957 6.90428 2.67424 7.24642 2.83133C7.59071 2.98841 7.86184 3.20466 8.0598 3.48009C8.25777 3.75337 8.36105 4.06754 8.36966 4.42258H7.40781Z",
    fill: "#FFB800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_745_10763",
    x: 0.798828,
    y: 0.800781,
    width: 10.4004,
    height: 10.4004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9125 0 0 0 0 0.679104 0 0 0 0 0.0798438 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_745_10763"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_745_10763",
    x: 3.54102,
    y: 2.5957,
    width: 4.91895,
    height: 6.81055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.960784 0 0 0 0 0.682353 0 0 0 0 0.235294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_745_10763"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/Coin.f4340e5de17378f84c622871e7d1421b.svg";
export { ForwardRef as ReactComponent };